"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuestionEditorCheck = void 0;
const InputAdornment_1 = __importDefault(require("@material-ui/core/InputAdornment"));
const FormQuestionType_1 = __importDefault(require("@opsbase/lib-form/FormQuestionType/FormQuestionType"));
const createFormQuestion_1 = __importDefault(require("@opsbase/lib-form/mutations/createFormQuestion"));
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
const Flag_1 = __importDefault(require("@opsbase/lib-issue/Flag/Flag"));
const IssueType_1 = require("@opsbase/lib-issue/IssueType");
const useCallforward_1 = __importDefault(require("@opsbase/react-hooks/useCallforward/useCallforward"));
const react_simple_reducer_1 = require("@opsbase/react-simple-reducer");
const useAltForSysLang_1 = __importDefault(require("@opsbase/web-ctrl-syslang/SysLangController/useAltForSysLang"));
const useSysLang_1 = __importDefault(require("@opsbase/web-ctrl-syslang/SysLangController/useSysLang"));
const Vertical_1 = __importDefault(require("@opsbase/web-layout/Vertical"));
const ColorPicker_1 = __importDefault(require("@opsbase/web-pickers/ColorPicker"));
const TextFieldWithStateAndBlur_1 = __importDefault(require("@opsbase/web-textfield/TextFieldWithStateAndBlur"));
const react_1 = __importStar(require("react"));
const useFedActions_1 = __importDefault(require("../../FedController/useFedActions"));
const QuestionEditorConditionTreeButton_1 = __importDefault(require("../QuestionEditorConditionTreeButton"));
const QuestionEditorFailButton_1 = __importDefault(require("../QuestionEditorFailButton"));
const QuestionEditorIssueButton_1 = __importDefault(require("../QuestionEditorIssueButton"));
const QuestionEditorScoringButtonMenu_1 = __importDefault(require("../QuestionEditorScoringButtonMenu"));
// eslint-disable-next-line no-shadow
var Options;
(function (Options) {
    Options["YES"] = "yes";
    Options["NO"] = "no";
})(Options || (Options = {}));
function optionLabel(o) {
    if (o === Options.YES)
        return lib_i18n_1.default.t('yes');
    if (o === Options.NO)
        return lib_i18n_1.default.t('no');
}
exports.QuestionEditorCheck = react_1.default.memo((props) => {
    const { config, onChange, qId, qTitle } = props;
    const { doExpand } = (0, useFedActions_1.default)();
    const { isAlt, language } = (0, useSysLang_1.default)();
    const [state, dispatch] = (0, react_1.useReducer)(react_simple_reducer_1.reducer, config);
    const [shouldExpand, setShouldExpand] = (0, react_1.useState)(false);
    const [value, setValue] = (0, react_1.useState)('');
    (0, react_1.useEffect)(() => {
        if (state !== config) {
            onChange(state);
            if (shouldExpand) {
                doExpand(qId, true);
                setShouldExpand(false);
                setValue('');
            }
        }
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [state, shouldExpand, value]);
    const handleChange = (0, useCallforward_1.default)(field => v => dispatch({ field, value: v }), []);
    const handleChangeLabel = (0, useCallforward_1.default)(yesNo => v => {
        if (isAlt) {
            dispatch({
                field: yesNo + '.labelAlt',
                value: Object.assign(Object.assign({}, config[yesNo].labelAlt), { [language]: v }),
            });
        }
        else {
            dispatch({ field: yesNo + '.label', value: v });
        }
    }, [config, isAlt, language]);
    const handleAddIssueQuestion = (0, react_1.useCallback)(subQuestions => {
        var _a;
        let questions = subQuestions.questions.filter(q => !!q.title) || [];
        const isIssueQuestionFound = (_a = subQuestions.questions) === null || _a === void 0 ? void 0 : _a.some(q => q.type === FormQuestionType_1.default.ISSUE);
        if (!isIssueQuestionFound) {
            questions = questions.concat((0, createFormQuestion_1.default)({
                title: 'Please include details',
                type: FormQuestionType_1.default.ISSUE,
                config: {
                    [FormQuestionType_1.default.ISSUE]: {
                        title: 'Problem with ' + qTitle,
                        type: IssueType_1.DefaultIssueTypeKeys.UNSPECIFIED,
                        flag: Flag_1.default.RED,
                    },
                },
            }));
        }
        else {
            questions = questions.filter(q => q.type !== FormQuestionType_1.default.ISSUE);
        }
        return {
            sqId: subQuestions.sqId,
            enabled: !!(questions === null || questions === void 0 ? void 0 : questions.length),
            questions: questions,
        };
    }, [qTitle]);
    const handleAddIssueQuestionToYes = (0, react_1.useCallback)(() => {
        const v = handleAddIssueQuestion(state.yes.subQuestions);
        dispatch({ field: 'yes.subQuestions', value: v });
        setShouldExpand(true);
        if (v.enabled) {
            setValue(state.yes.label);
        }
    }, [handleAddIssueQuestion, state.yes.label, state.yes.subQuestions]);
    const handleAddIssueQuestionToNo = (0, react_1.useCallback)(() => {
        const v = handleAddIssueQuestion(state.no.subQuestions);
        dispatch({ field: 'no.subQuestions', value: v });
        setShouldExpand(true);
        if (v.enabled) {
            setValue(state.no.label);
        }
    }, [handleAddIssueQuestion, state.no.label, state.no.subQuestions]);
    const handleChangeYesSubquestions = (0, react_1.useCallback)(() => {
        var _a;
        const subQuestions = state.yes.subQuestions;
        const enabled = subQuestions ? !subQuestions.enabled : false;
        //remove issue question if we are disabling
        const questions = subQuestions.questions
            ? enabled
                ? subQuestions.questions
                : ((_a = subQuestions.questions) === null || _a === void 0 ? void 0 : _a.filter(q => q.type !== FormQuestionType_1.default.ISSUE)) || []
            : [];
        const v = {
            sqId: subQuestions.sqId,
            enabled,
            questions,
        };
        dispatch({ field: 'yes.subQuestions', value: v });
        setShouldExpand(true);
        if (v.enabled) {
            setValue(state.yes.label);
        }
    }, [state.yes.label, state.yes.subQuestions]);
    const handleChangeNoSubquestions = (0, react_1.useCallback)(() => {
        var _a;
        const subQuestions = state.no.subQuestions;
        const enabled = subQuestions ? !subQuestions.enabled : false;
        //remove issue question if we are disabling
        const questions = subQuestions.questions
            ? enabled
                ? subQuestions.questions
                : ((_a = subQuestions.questions) === null || _a === void 0 ? void 0 : _a.filter(q => q.type !== FormQuestionType_1.default.ISSUE)) || []
            : [];
        const v = {
            sqId: subQuestions.sqId,
            enabled,
            questions,
        };
        dispatch({ field: 'no.subQuestions', value: v });
        setShouldExpand(true);
        if (v.enabled) {
            setValue(state.no.label);
        }
    }, [state.no.label, state.no.subQuestions]);
    const handleChangeYesClickMarkFail = (0, react_1.useCallback)(() => {
        dispatch({ field: 'no.fail', value: false });
        dispatch({ field: 'yes.fail', value: true, toggle: true });
    }, []);
    const handleChangeNoClickMarkFail = (0, react_1.useCallback)(() => {
        dispatch({ field: 'yes.fail', value: false });
        dispatch({ field: 'no.fail', value: true, toggle: true });
    }, []);
    return (react_1.default.createElement(Vertical_1.default, null,
        react_1.default.createElement(Option, Object.assign({ t: Options.YES, onChangeLabel: handleChangeLabel('yes'), onChangeFlag: handleChange('yes.flag'), onMarkFail: handleChangeYesClickMarkFail, onChangeScore: handleChange('yes.score'), onClickCondition: handleChangeYesSubquestions, onClickAddIssue: handleAddIssueQuestionToYes, config: state }, props)),
        react_1.default.createElement(Option, Object.assign({ t: Options.NO, onChangeLabel: handleChangeLabel('no'), onChangeFlag: handleChange('no.flag'), onMarkFail: handleChangeNoClickMarkFail, onChangeScore: handleChange('no.score'), onClickCondition: handleChangeNoSubquestions, onClickAddIssue: handleAddIssueQuestionToNo, config: state }, props))));
});
exports.default = exports.QuestionEditorCheck;
const Option = react_1.default.memo((props) => {
    const { config, scoring, immediateFailAvailable, t, onChangeLabel, onChangeScore, onChangeFlag, onClickCondition, onClickAddIssue, onMarkFail, disabled, } = props;
    const { flag, subQuestions, score, fail } = config[t];
    const [label] = (0, useAltForSysLang_1.default)(config[t].label, config[t].labelAlt);
    const startAdornment = (0, react_1.useMemo)(() => scoring ? (react_1.default.createElement(InputAdornment_1.default, { position: "start" },
        react_1.default.createElement(QuestionEditorScoringButtonMenu_1.default, { disabled: disabled, score: score, onChange: onChangeScore }))) : undefined, [scoring, disabled, score, onChangeScore]);
    const endAdornment = (0, react_1.useMemo)(() => {
        var _a;
        return (react_1.default.createElement(InputAdornment_1.default, { position: "end" },
            react_1.default.createElement(ColorPicker_1.default, { disabled: disabled, noMargin: true, noBorder: true, value: flag, onChange: onChangeFlag }),
            immediateFailAvailable && (react_1.default.createElement(QuestionEditorFailButton_1.default, { disabled: disabled, enable: fail, onClick: onMarkFail })),
            react_1.default.createElement(QuestionEditorConditionTreeButton_1.default, { enable: (subQuestions === null || subQuestions === void 0 ? void 0 : subQuestions.enabled) ? subQuestions.enabled : false, disabled: disabled, isLabel: label && label !== '', onClick: onClickCondition }),
            react_1.default.createElement(QuestionEditorIssueButton_1.default, { enable: (subQuestions === null || subQuestions === void 0 ? void 0 : subQuestions.enabled) &&
                    ((_a = subQuestions === null || subQuestions === void 0 ? void 0 : subQuestions.questions) === null || _a === void 0 ? void 0 : _a.some(q => q.type === FormQuestionType_1.default.ISSUE)), disabled: disabled, isLabel: label && label !== '', onClick: onClickAddIssue })));
    }, [
        disabled,
        flag,
        onChangeFlag,
        immediateFailAvailable,
        fail,
        onMarkFail,
        subQuestions.enabled,
        subQuestions === null || subQuestions === void 0 ? void 0 : subQuestions.questions,
        label,
        onClickCondition,
        onClickAddIssue,
    ]);
    return (react_1.default.createElement(TextFieldWithStateAndBlur_1.default, { disabled: disabled, value: label, fullWidth: true, placeholder: optionLabel(t), onBlur: onChangeLabel, InputProps: {
            startAdornment,
            endAdornment,
        } }));
});
